import { pintHttp } from '@api/client';
import { pickResult, cachedApi } from '@api/utils';
import * as Pint from './pint';
import { map } from 'rxjs/operators';
/**
 * Get the masters from PINT.
 */
export const getPintMasters = cachedApi(() =>
  pintHttp.get<Pint.MasterResponse>(`api/v1/cmd/masters`).pipe(
    pickResult(),
    map(data => {
      const subtypeData = {};
      const dealBadges = data.deal_badges;
      dealBadges.forEach(
        z =>
          (subtypeData[z.name] = z.subtypes.map(x => data.deal_subtypes.filter(y => y.id == x)[0]))
      );
      return {
        ...sortData(data),
        deal_subtypes: subtypeData,
        unique_deal_subtypes: data.deal_subtypes.sort((x, y) => x.name.localeCompare(y.name)),
        relationship: data.company_relations.sort((x, y) => x.name.localeCompare(y.name)),
        reputation: data.reputation_badge,
      };
    })
  )
);

function sortData(data: Pint.MasterSet): Pint.MasterSet {
  const temp_data = {};
  Object.entries(data).forEach(
    x => (temp_data[x[0]] = x[1].sort((x, y) => x?.name?.localeCompare(y.name)))
  );
  return temp_data as Pint.MasterSet;
}

// Group Company-1
// Brand-2
// App Marketplace-3
// FAST Channel Aggregator-4
// Operator-5
// Competition-6
